import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DropdownState {
  [key: number]: boolean;
}

const initialState: DropdownState = {};

const dropdownSlice = createSlice({
  name: "dropdown",
  initialState,
  reducers: {
    toggleDropdown: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      state[index] = !state[index];
    },
  },
});

export const { toggleDropdown } = dropdownSlice.actions;
export default dropdownSlice.reducer;
